import { myPagesBaseApi } from '~/store/apis/endpoints/_baseApi/myPages.base.api';
import { Application } from '~/models/application/application';
import {
  ApplicationPostRequestDto,
  ClientApplicationGetRequestDto,
  ClientApplicationGetResponseDto,
} from '~/store/apis/dtos/applications/application.dto';

import { mapClientApplication } from '~/store/apis/endpoints/myPages/applications/applications.mapper';
import { generateParams } from '~/store/apis/utils/generateParams';

export const applicationsApi = myPagesBaseApi.injectEndpoints({
  endpoints: (builder) => ({
    getApplication: builder.query<
      Application | undefined,
      ClientApplicationGetRequestDto
    >({
      query: () => `/applications/client`,
      providesTags: ['Applications'],
      transformResponse: (
        response: ClientApplicationGetResponseDto,
        _meta,
        args
      ) => mapClientApplication(response, args),
    }),
    postApplication: builder.mutation<any, ApplicationPostRequestDto>({
      query: (arg) => ({
        url: `/applications?${generateParams(arg)}`,
        method: 'POST',
      }),
    }),
  }),
});

export const {
  useGetApplicationQuery,
  usePostApplicationMutation,
} = applicationsApi;
